import { DestroyRef, inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';

import { AppNotification } from '../../proxy/models/app-notification';
import { NOTIFICATIONS_URL } from '../global/config';
import { IS_PRODUCTION } from '../global/constants/constant';

@Injectable({
  providedIn: 'root',
})
export class AppNotificationsService {
  private destroyRef = inject(DestroyRef);
  private readonly http = inject(HttpClient);
  private readonly notificationsUrl = inject(NOTIFICATIONS_URL);

  private notificationsObservable$ = new BehaviorSubject<AppNotification[]>([]);
  public notifications = this.notificationsObservable$.asObservable();

  public getNotifications(): void {
    const data = {
      env: IS_PRODUCTION ? 'PRD' : 'UAT',
      org: 'SAL',
      app: 'Surveys',
    };

    this.http.post(this.notificationsUrl, data).pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((value) => {
      this.notificationsObservable$.next(value as AppNotification[]);
    })
  }
}
